import "react-circular-progressbar/dist/styles.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import styled from "styled-components";

import { merchantApi } from "@api";
import { ArrowLeftColor } from "@components";
import { PATH_SIGN_UP, PATH_SIGN_UP_FORM, PATH_SURVEY, enumStatus } from "@configs";
import { IMemberTier, ISurvey } from "@interfaces";
import { fetchUser, selectAuth, selectMerchant } from "@redux";
import UserStore from "@Rocket-Innovation/components/store/UserStore";
import UIStore from "@Rocket-Innovation/components/store/useUIStore";
import { RenderMeta, formatMessage, isExpired, useNotify } from "@utils";
import { Input, Rate, Select } from "antd";
import { useEffect, useState } from "react";
import { IconPoint } from "./icon/Point";

const { Option } = Select;
interface IProps {
    avatar: string;
    fullName: string;
    memberTier: IMemberTier | undefined;
    // onChangeProvince: (value: any) => void;
}

export const ComponentSurveyDetail = (props: IProps) => {
    //page hook
    const { t } = useTranslation();
    //push route
    const history = useHistory();
    const { success, warning, error } = useNotify();

    const { id, surveyType } = useParams<{ id: string; surveyType: string }>();
    //page props
    const { avatar, fullName, memberTier } = props;
    //redux statex
    const { auth, userInfo } = useSelector(selectAuth);

    const [showpopupsurvey, setShowPopupSurvey] = useState(false);
    const { themes } = useSelector(selectMerchant);
    const [loadBtn, setLoadBtn] = useState<boolean>(false);
    const merchant = useSelector(selectMerchant);
    const [surveyList, setSurveyList] = useState<ISurvey[]>([]);
    const [thisSurvey, setThisSurvey] = useState<ISurvey>();
    const [ansList, setAnsList] = useState<any[]>([]);
    const dispatch = useDispatch();
    const surveyPointGiven = Number(thisSurvey?.pointGiven || 0);

    const token = UserStore.getState().accessToken ?? auth?.accessToken;

    const checkIsLogin = () => {
        if (localStorage.getItem("SURVEY")) {
            localStorage.removeItem("SURVEY");
        }
        if (!token) {
            localStorage.setItem("SURVEY", id);
            warning("Please sign in to continue");
            history.push(PATH_SIGN_UP);
            return true;
        } else if (userInfo?.status === enumStatus.INACTIVE) {
            localStorage.setItem("SURVEY", id);
            history.push(PATH_SIGN_UP_FORM);
            return true;
        } else {
            return false;
        }
    };

    useEffect(() => {
        if (id && !checkIsLogin()) {
            fetchSurvey();
        }
    }, [id]);

    const fetchSurvey = async () => {
        // let res = await merchantApi.getSurveyList();
        try {
            const data = await merchantApi.getSurveyDetails(id);
            if (data.data) {
                const findSurvey = data.data;
                setThisSurvey(findSurvey);
                let ansArr: any[] = [];
                findSurvey.fields.forEach((element: any) => {
                    if (element.isFreeTextAnswer) {
                        ansArr.push("");
                    } else if (element.isStarPoint) {
                        ansArr.push(0);
                    } else if (element.multiple) {
                        ansArr.push([]);
                    } else {
                        ansArr.push("");
                    }
                });
                setAnsList(ansArr);
                if (findSurvey?.completed) {
                    success("Already Submit this Survey");
                    history.push(PATH_SURVEY);
                } else if (!findSurvey?.turnOn) {
                    warning("Can not do this survey");
                    history.push(PATH_SURVEY);
                } else if (isExpired(new Date(findSurvey?.till))) {
                    warning("Survey expired");
                    history.push(PATH_SURVEY);
                } else if (!findSurvey?.isAllmemberType) {
                    if (findSurvey?.memberType[0].groupId !== "") {
                        if (
                            !findSurvey?.memberType?.some((item: any) =>
                                item.type.includes(userInfo?.contact?.memberTypeNameId)
                            )
                        ) {
                            warning("Can not do this survey");
                            history.push(PATH_SURVEY);
                        }
                    }
                } else if (findSurvey?.isOneTime) {
                    warning("Can not do this survey");
                    history.push(PATH_SURVEY);
                }
            }
        } catch (err: any) {
            error(formatMessage(err.response));
            history.push(PATH_SURVEY);
        }

        // let findSurvey = await res.data?.find((x: any) => x._id === id);

        // setSurveyList(res?.data);
    };

    const changeTextAnswer = (e: any, qIndex: number) => {
        let arr = ansList;
        arr[qIndex] = e.target.value;
    };

    const handleChange = (value: any, qIndex: number) => {
        let arr = ansList;
        arr[qIndex] = value;
    };
    const onChangeRate = (point: any, qIndex: number) => {
        let arr = ansList;
        arr[qIndex] = point;
    };

    const confirmSurvey = () => {
        setShowPopupSurvey(false);
        history.push(PATH_SURVEY);
    };

    const onSendSurvey = async () => {
        if (!loadBtn) {
            try {
                setLoadBtn(true);
                let arr: any[] = [];
                thisSurvey?.fields?.forEach((element, tIndex: number) => {
                    let qObj: any = {
                        isRequired: thisSurvey.fields[tIndex].isRequired,
                        question: thisSurvey.fields[tIndex]?.fieldName,
                        propertyName: thisSurvey.fields[tIndex]?.propertyName,
                        questionId: thisSurvey.fields[tIndex]?._id,
                        freeTextAnswer:
                            thisSurvey.fields[tIndex].isFreeTextAnswer ||
                            (!thisSurvey.fields[tIndex].isFreeTextAnswer &&
                                !thisSurvey.fields[tIndex].isStarPoint &&
                                !thisSurvey.fields[tIndex].multiple)
                                ? ansList[tIndex]
                                : "",
                        starPointAnswer: thisSurvey.fields[tIndex].isStarPoint
                            ? ansList[tIndex].toString()
                            : "",
                        answers:
                            !thisSurvey.fields[tIndex].isFreeTextAnswer &&
                            !thisSurvey.fields[tIndex].isStarPoint &&
                            thisSurvey.fields[tIndex].multiple
                                ? ansList[tIndex]
                                : [],
                    };
                    //@ts-ignore
                    arr.push(qObj);
                });
                let payload = {
                    questionId: id,
                    surveyAnswers: arr,
                };
                UIStore.setState({ isLoading: true });
                let res = await merchantApi.sendSurveyAns(payload);
                if (res?.status === 201) {
                    setShowPopupSurvey(true);
                    localStorage.removeItem("SURVEY");
                    dispatch(fetchUser());
                }
            } catch (err: any) {
                console.error(err);

                error(formatMessage(err.response));
            } finally {
                localStorage.removeItem("SURVEY");
                UIStore.setState({ isLoading: false });
                setLoadBtn(false);
            }
        }
    };

    return (
        <>
            <RenderMeta title="survey page" />
            <StyledSurveyDetail themeColor={themes?.themeColor!}>
                <header>
                    {surveyType !== "link" && (
                        <div className="back-arrow">
                            <ArrowLeftColor
                                color={themes?.themeColor}
                                onClick={() => {
                                    sessionStorage.removeItem("SURVEY");
                                    history.goBack();
                                }}
                            />
                            {/* <span>{t("page.back")}</span> */}
                        </div>
                    )}
                    <div className="logo-product">
                        {/* <img src="../images/logo-pet.svg" alt="" /> */}
                    </div>
                    <div className="logo-survey">
                        {/* <img src="../images/logo-survey.svg" alt="" /> */}
                        Survey
                    </div>
                </header>
                <div className="title-survey">{thisSurvey?.surVeyName}</div>
                <div className="banner-survey-detail">
                    <span>
                        <img src={thisSurvey?.welcomeScreenImages[0]} alt="" />
                    </span>
                </div>
                {thisSurvey?.fields?.map((qItem, qIndex) => {
                    return (
                        <div className="input-survey-detail" key={qIndex}>
                            <p className="input-title ">{qItem?.fieldName}</p>
                            {qItem?.isFreeTextAnswer && (
                                <Input
                                    className="survey-input"
                                    onChange={(e) => {
                                        changeTextAnswer(e, qIndex);
                                    }}
                                />
                            )}
                            {!qItem?.isFreeTextAnswer && !qItem?.isStarPoint && (
                                <Select
                                    onChange={(value: string) => handleChange(value, qIndex)}
                                    mode={qItem?.multiple ? "multiple" : undefined}
                                    showArrow={true}
                                >
                                    {qItem?.options?.map((oItem: any, oIndex: number) => {
                                        return (
                                            <Option value={oItem?.optionName} key={oIndex}>
                                                {oItem?.optionName}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            )}
                            {qItem?.isStarPoint && (
                                <Rate
                                    onChange={(point) => onChangeRate(point, qIndex)}
                                    // value={ansList[qIndex]}
                                />
                            )}
                        </div>
                    );
                })}
                <div className="btn-popupsurvey">
                    <StyledUsedBtn
                        className="btn-redeem"
                        themeColor={themes?.themeColor!}
                        // onClick={() => { setShowPopupSurvey(true); }}
                        onClick={onSendSurvey}
                    >
                        Send
                    </StyledUsedBtn>
                </div>
                {showpopupsurvey ? (
                    <StyledPopupSurvey themeColor={themes?.themeColor!}>
                        <div className="box-popupsurvey">
                            <div className="img-popupsurvey">
                                <img
                                    src={merchant?.themes?.basicThemeSetting?.iconGeneral[0].image}
                                    alt=""
                                />
                            </div>
                            <div className="subtext-popupsurvey">{t("page.congratulation")}</div>
                            <div className="title">
                                {surveyPointGiven > 0 ? (
                                    <div className="text-sub-header">
                                        <span>
                                            <IconPoint />
                                        </span>{" "}
                                        {t("page.youget")} {surveyPointGiven} {t("page.point")}
                                    </div>
                                ) : (
                                    <div className="text-sub-header">
                                        {t("page.survey_submit_success_no_point")}
                                    </div>
                                )}
                            </div>
                            <div className="btn-popupsurvey">
                                <StyledUsedBtn
                                    className="btn-redeem"
                                    themeColor={themes?.themeColor!}
                                    onClick={() => {
                                        confirmSurvey();
                                    }}
                                >
                                    {t("page.done")}
                                </StyledUsedBtn>
                            </div>
                        </div>
                    </StyledPopupSurvey>
                ) : null}
            </StyledSurveyDetail>
        </>
    );
};

const StyledUsedBtn = styled.button<{ themeColor: string }>`
    width: 100%;
    height: 48px;
    border-radius: 50px;
    font-weight: 600;
    box-shadow: none;
    color: ${(p) => p.theme.colors.card};
    background: ${(p) => p.themeColor};
    border: 0.5px solid ${(p) => p.theme.colors.card};
    font-size: 15px;
`;

const StyledPopupSurvey = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    /* left:0; */
    margin-left: -15px;
    .box-popupsurvey {
        background: ${(p) => p.theme.colors.card};
        padding: 70px 28px 28px;
        border-radius: 8px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .subtext-popupsurvey {
            color: #666666;
            font-size: 16px;
            line-height: 20px;
            margin-bottom: 5px;
            text-align: center;
        }
        .img-popupsurvey {
            position: absolute;
            top: -60px;
            left: 50%;
            transform: translateX(-50%);
            img {
                max-width: 115px;
            }
        }
        .btn-popupsurvey {
            display: grid;
            grid-template-columns: 1fr;
            gap: 16px;
            .btn-redeem {
                color: ${(p) => p.theme.colors.card};
                background: ${(p) => p.themeColor};
                border: 0.5px solid ${(p) => p.theme.colors.card};
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
                border: none;
                font-weight: 600;
            }
        }
    }
    .title {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        justify-content: center;
        margin-bottom: 20px;
        .text-sub-header {
            font-size: 18px;
            line-height: 21px;
            color: #000;
            font-weight: 600;
        }
    }
`;

const StyledSurveyDetail = styled.div<{ themeColor: string }>`
    width: 100%;
    margin: 0 auto;
    min-height: 100vh;
    background-color: #fff;
    background-position: right top;
    background-repeat: no-repeat;
    padding: 0 15px;
    .logo-survey {
        font-size: 32px;
        color: ${(p) => p.themeColor};
        font-weight: 600;
    }
    .back-arrow {
        position: absolute;
        left: 10px;
        display: flex;
        align-items: center;
        span {
            margin-left: 10px;
            color: ${(p) => p.themeColor};
        }
    }
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        .title-group {
            text-align: center;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: #000000;
        }
    }
    .title-survey {
        font-size: 24px;
        line-height: 30px;
        color: #222;
        font-weight: 600;
        margin-bottom: 15px;
    }
    .banner-survey-detail {
        width: 100%;
        padding-top: 40%;
        position: relative;
        margin-bottom: 30px;
        border-radius: 16px;
        overflow: hidden;
        span {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
    .rating-survey-detail {
        margin-bottom: 50px;
    }
    .input-survey-detail {
        margin-bottom: 30px;
        .input-title {
            font-size: 14px;
            line-height: 17px;
            color: #000;
            margin-bottom: 5px;
        }

        .ant-select {
            width: 100%;
            .ant-select-selection {
                box-shadow: none !important;
                height: 65px;
                font-size: 14px;
                color: ${(p) => p.themeColor};
                display: flex;
                flex-direction: column;
                justify-content: center;
                border-radius: 16px;
                width: 100%;
                background-color: ${(p) => p.theme.colors.card};
                border: 1px solid ${(p) => p.themeColor};
                cursor: default;
            }
            .ant-select-arrow {
                color: ${(p) => p.themeColor};
            }
        }
    }
    .survey-input {
        box-shadow: none !important;
        height: 65px;
        font-size: 14px;
        color: ${(p) => p.themeColor};
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-radius: 16px;
        width: 100%;
        background-color: ${(p) => p.theme.colors.card};
        border: 1px solid ${(p) => p.themeColor};
        cursor: default;
    }
    .ant-select-selection--multiple {
        .ant-select-arrow {
            margin-top: 10px;
            top: 8px;
        }
    }
`;
